import axios from 'axios';
import { useStore } from 'vuex'; 

const isAuthenticatedGuard =  async( to, from, next ) =>{
  const store = useStore()
  const token = localStorage.getItem('token')

  if (!token) {
    return next({ name: 'login' })
  }
  
  try {
    const { data: user } = await axios.get('auth/token', {
      headers: { token }
    })
    await store.dispatch('saveUser', user)
    next() 
  } catch (error) {
    console.warn('Token inválido o expirado', error)
    localStorage.removeItem('token')
    next({ name: 'login' })
  }
}
export default isAuthenticatedGuard